import React from 'react';
import { motion } from 'framer-motion';
import { Star, Dog, Cat } from 'lucide-react';
const testimonials = [{
  name: 'Laura M.',
  pet: 'Rocky, Labrador de 4 años',
  type: 'dog',
  text: 'Llevaba años dándole pienso premium y pensaba que era suficiente. Desde que empecé con las recetas de la guía, Rocky tiene más energía, mejor pelo y hasta le ha mejorado la digestión. Ojalá lo hubiera hecho antes.',
  stars: 5
}, {
  name: 'Carlos R.',
  pet: 'Luna, Gata persa de 6 años',
  type: 'cat',
  text: 'Mi gata siempre fue muy selectiva con la comida. Con esta guía encontré recetas que le encantan y que además son equilibradas. Lo mejor es la parte de suplementos con taurina, que me daba mucho respeto hacer sola.',
  stars: 5
}, {
  name: 'Marta G.',
  pet: 'Thor, Pastor alemán senior de 10 años',
  type: 'dog',
  text: 'Thor tiene artrosis y el veterinario me recomendó mejorar su alimentación. La sección de perros senior me salvó. Recetas fáciles, con omega 3 incluido, y la transición desde el pienso fue súper gradual. Se nota el cambio.',
  stars: 5
}, {
  name: 'Javier P.',
  pet: 'Miso, Gato común de 2 años',
  type: 'cat',
  text: 'Siempre quise darle comida casera a Miso pero me daba miedo hacerlo mal. La guía te lleva paso a paso, sin complicaciones. Ahora preparo por lotes los domingos y tengo comida para toda la semana. Más barato que el pienso que compraba.',
  stars: 5
}];
export function Testimonials() {
  return <section className="py-12 md:py-24 bg-dark-800" data-id="element-108">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-110">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-111">
            Lo que dicen quienes ya la usan
          </h2>
          <p className="text-lg text-gray-400" data-id="element-112">
            Dueños reales, resultados reales.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-113">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.6
        }} className="bg-dark-900 rounded-2xl p-8 border border-gray-800 flex flex-col" data-id="element-114">
              <div className="flex items-center gap-1 mb-4" data-id="element-115">
                {Array.from({
              length: t.stars
            }).map((_, i) => <Star key={i} className="w-5 h-5 fill-earth-amber text-earth-amber" data-id="element-116" />)}
              </div>

              <p className="text-gray-300 text-lg leading-relaxed mb-6 flex-1 italic" data-id="element-117">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-gray-800" data-id="element-118">
                <div className="w-10 h-10 rounded-full bg-dark-800 flex items-center justify-center" data-id="element-119">
                  {t.type === 'dog' ? <Dog className="w-5 h-5 text-earth-amber" data-id="element-120" /> : <Cat className="w-5 h-5 text-earth-green" data-id="element-121" />}
                </div>
                <div data-id="element-122">
                  <p className="text-white font-semibold" data-id="element-123">{t.name}</p>
                  <p className="text-gray-500 text-sm" data-id="element-124">{t.pet}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}